import { useState } from "react";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import MainButton from "../../Buttons/MainButton";

export default function DB_Archive() {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Row>
        <Col>
          <Title title={"أرشفة قاعدة البيانات"} />
        </Col>
      </Row>
      <Row justify={"around"}>
        <Col lg={10} sm={10} md={10}>
          <MainButton
            titlebtn=" أرشفة القاعدة "
            className="w-full !border-2  "
            onClick={() => setOpen(true)}
          />
        </Col>
      </Row>

      {open && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"start"}
              className="relative bg-white w-[500px] h-[25vh]   border-2 border-white rounded-lg  "
            >
              <div
                className="absolute top-5   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setOpen(!open)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center items-center !mt-3">
                <Title title="هل انت متأكد من أرشفة قاعدة البيانات" />
              </Col>

              <Col className="flex justify-evenly  ">
                <Col lg={5} md={5} sm={5}>
                  <MainButton
                    titlebtn="الغاء"
                    className="w-[100%]  bg-white text-[#d46ebb] border-2 border-[#d46ebb] hover:bg-[#d46ebb] hover:text-white"
                    onClick={() => setOpen(false)}
                  />
                </Col>
                <Col lg={5} md={5} sm={5}>
                  <MainButton titlebtn="نعم" className="w-[100%] " />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
}
